module.exports = {
  name: {
    home: 'Home',
    data: 'Data',
    permission: 'Permission',
    member: 'Member',
    agent: 'Agent',
    setting: 'Setting',
    login: 'Login',
    logout: 'Logout',
    country: 'Country',
    phone: 'Phone',
    account: 'Account',
    sms_code: 'SMS Code',
    password: 'Password',
    to: 'To',
    all: 'All',
    source: 'Source',
    target: 'Target',
    success: 'Success',
    succeed: 'Succeed',
    failed: 'Failed',
    error: 'Error',
    status: 'Status',
    state: 'State',
    detail: 'Detail',
    add: 'Add',
    added: 'Added',
    name: 'Name',
    type: 'Type',
    secret_type: 'Secret Type',
    method: 'Method',
    cancel: 'Cancel',
    canceled: 'Canceled',
    ok: 'OK',
    run: 'Run',
    running: 'Running',
    action: 'Action',
    actions: 'Actions',
    delete: 'Delete',
    deleted: 'Deleted',
    pass: 'Pass',
    passed: 'Passed',
    hit: 'Hit',
    rename: 'Rename',
    save: 'Save',
    config: 'Config',
    schedule: 'Schedule',
    transaction: 'Transaction',
    pipeline: 'Pipeline',
    history: 'History',
    generate: 'Generate',
    address: 'Address',
    edit: 'Edit',
    copy: 'Copy',
    paste: 'Paste',
    field: 'Field',
    writeback: 'Writeback',
    digit: 'Digit',
    start: 'Start',
    end: 'End',
    rule: 'Rule',
    minute: 'Minute',
    hour: 'Hour',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    value: 'Value',
    team: 'Team',
    log: 'Log',
    search: 'Search',
    query: 'Query',
    reset: 'Reset',
    variable: 'Variable',
    profile: 'Profile',
    username: 'User Name',
    nickname: 'Nick Name',
    bind: 'Bind',
    unbind: 'Unbind',
    change: 'Change',
    code: 'Code',
    authorization: 'Authorization',
    storage: 'Storage',
    record: 'Record',
    group: 'Group',
    pending: 'Pending',
    company: 'Company',
    check: 'Check',
    doc: 'Document',
    default: 'Default',
    open: 'Open',
    received: 'Received',
    mapping: 'Mapping',
    exit: 'Exit',
    continue: 'Continue',
    desc: 'Desc',
    proc: 'Process',
    download: 'Download',
    view: 'View',
    trigger: 'Trigger',
    schema: 'Schema',
    simple: 'Simple',
    manual: 'Manual',
    loop: 'Loop',
    split: 'Split',
    break: 'Break',
    env: 'Env',
    get_output: 'Get Output',
    json: 'JSON',
    agent_sql: 'SQL',
    http: 'HTTP',
    pipeline_link: 'Pipeline Link',
    jq: 'JQ',
    json_schema: 'JsonSchema',
    open_webhook: 'Open WebHook',
    open_notify: 'Open Notify',
    open_alert: 'Open Alert',
    always_debug: 'Always Debug',
    input_describe: 'Input Describe',
    output_describe: 'Output Describe',
    step: 'Step',
    record_write: 'Record Write',
    record_read: 'Record Read',
    record_confirm: 'Record Confirm',
    pipeline_usage: 'Pipeline Usage',
    pipeline_count: 'Pipeline Count',
    proc_times: 'Process Times',
    common_pipeline: 'Common Pipeline',
    recent_proc: 'Recent Process',
    direct: 'Direct',
    db_config: 'DB Config',
    db_type: 'DB Type',
    host: 'Host',
    port: 'Port',
    db_name: 'DB Name',
    user_name: 'User Name',
    redis_check: 'Data Check',
    agent_file: 'Read File',
    file_path: 'File Path',
    upload_file: 'Upload File',
    file_name: 'File Name',
    customer_condition: 'Customer Condition',
    mark: 'Mark',
    warn: 'Warn',
    receive_status: 'Receive Status',
    last_receive_time: 'Last Receive Time',
    error_info: 'Error Info',
    receive_details: 'Receive Details',
    click_toview: 'Click to View',
    start_at: 'Start At',
    interval: 'Interval',
    timing: 'Timing',
    frequency: 'Frequency',
    effective_time_period: 'Effective Time Period',
    webservice: 'webservice',
    oss: 'Tencent Oss',
    oss_config: 'Oss Config',
    bucket_name: 'Bucket',
    app_id: 'APP ID',
    secret_id: 'Secret ID',
    secret_key: 'Secret Key',
    region: 'Region',
    init: 'Init',
    edge: 'Edge',
    update: 'Update',
    last_update_time: 'Last Update Time',
    tag: 'Tag',
    xml2json: 'Xml To Json',
    publish: 'Publish',
    topic_name: 'Topic Name',
    subscribe_name: 'Subscribe Name',
    create_topic: 'Create Topic',
    create_subscribe: 'Create Subscribe',
    edit_subscribe: 'Edit Subscribe',
    create: 'Create',
    listen_method: 'Listen Method',
    delete_topic: 'Delete Topic',
    delete_subscribe: 'Delete Subscribe',
    publish_message: 'Publish Message',
    client_list: 'Client List',
    topic_manage: 'Topic Manage',
    client_id: 'Client ID',
    client_ip: 'Client IP',
    get_token: 'Get Token',
    context_type: 'Context Type',
    step_info: 'Step Info',
    jump_detail: 'Detail',
    branch_judge: 'Branch Judge',
    judging_condition: 'Judging Condition',
    action_type: 'Action Type',
    file_data: 'File Data',
    amqp: 'AMQP',
    newlink: 'New Link',
    server: 'Server',
    user: 'User',
    exchange: 'Exchange',
    queue: 'Queue',
    delete_amqp: 'Delete AMQP',
    exchange_type: 'Exchange Type',
    route_key: 'Route Key',
    auto_ack: 'Auto ACK',
    message_count: 'Message Count',
    amqp_ack: 'AMQP ACK',
    auto_delete: 'Auto Delete',
    durable: 'Durable',
    download_file: 'Download File',
    suffix: 'Suffix',
    suffix_tip: 'Append an extension to the file name (keep the original file name if empty)',
    edge_status: 'Server Status',
    expire_time: 'Expire Time',
  },
  message: {
    please_enter: 'Please entry',
    please_choice: 'Please choice',
    please_enter_something: 'Please entry {msg}',
    please_choice_something: 'Please choice {msg}',
    get_code: 'Get Code',
    get_sms_code: 'Get SMS Code',
    try_again: 'Try again',
    date_start: 'Date Start',
    date_end: 'Date End',
    finished_at: 'Finished At',
    data_status: 'Data Status',
    recent_transfer: 'Recent Transfer',
    latest_week: 'Latest week',
    latest_month: 'Latest month',
    last_three_months: 'Last 3 months',
    latest_transfer_time: 'latest transfer time',
    delete_confirm: 'The action will delete, Are you sure to continue ?',
    reset_confirm: 'The action will reset the record, after reset you will receive the record again, Are you sure to continue ?',
    pass_confirm: 'The action will pass the record, after reset you will does not receive the record again, Are you sure to continue ?',
    something_invalid: '{msg} invalid',
    something_required: '{msg} is required!',
    something_succeed: '{msg} succeed!',
    something_failed: '{msg} failed!',
    operation_succeed: 'The operation succeed!',
    operation_failed: 'The operation failed!',
    running_succeed: 'Running succeed!',
    running_failed: 'Running failed!',
    data_format: 'Data format',
    string_list: 'String List',
    string_regexp: 'String Regexp',
    paste_formated_json: 'Paste enter foramted json',
    copy_succeed: 'Copy succeed!',
    copy_failed: 'Copy failed!',
    new_node: 'New node',
    api_request_failed: 'Data request failed!',
    schedule_hour: '{minute} minute every hour',
    schedule_day: '{hour}:{minute} every day',
    schedule_week: '{hour}:{minute} on {weekday}',
    schedule_month: '{hour}:{minute} on {day_of_month}th every month',
    please_choice_target_data: 'Please choice a target data',
    reset_agent_key_hit: 'After reset the old key will invalid, are your sure to continue?',
    env_variable: 'Env variable',
    add_team: 'Add new team',
    change_to_team: 'Change to the team {msg}',
    something_alert: '{msg} alert',
    change_something: 'Change {msg}',
    phone_source: 'Source phone',
    phone_new: 'New phone',
    phone_no_bind: 'Please bind phone before!',
    password_new: 'New Password',
    password_confirm: 'Confirm Password',
    password_inconsistent: 'New Password and Confirm Password inconsistent',
    password_invalid: 'Password invalid, it\'s length must be {min} to {max}',
    record_time: 'Record Time',
    update_time: 'Update Time',
    deleted_time: 'Deleted Time',
    please_run_in_transaction: 'Please run in transaction',
    user_not_exist_invite: 'User not exist. Would you invite the user?',
    for_check: 'for Check',
    open_data_is_readonly: 'This is open data, it\'s read only!',
    error_action: 'Error action',
    error_action_hint_exit: 'Exit when Process execute error.',
    error_action_hint_continue: 'Continue when process execute error',
    error_retry_times: 'Error retry times',
    action_batch: 'Action Batch',
    change_to_new_version: 'Change to new version',
    back_to_old_version: 'Back to old version',
    change_version: 'Change version',
    merge_result: 'Merge Result',
    list_number: 'List Number',
    pipeline_limit: 'Pipeline Count Reached the Upper Limit',
    proc_limit: 'Proc Times Reached the Upper Limit',
    auto_generate: '(If not filled in, it will be automatically generated)',
    mqtt_service_info: 'Service Address: mqtts://m.dotflow.cn:80'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en-US.js